// extracted by mini-css-extract-plugin
module.exports = {"boomerHeadingText":"BoomerHeading_boomerHeadingText__14T8r"};